import { ContainerStatusEnum } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { Container } from '../container.entity';
import { BookContainerDto } from './book-container.dto';
import { DispatchedToPlant } from './container-dispatched-to-plant.dto';
import { ContainerDTO } from './container.dto';
import { FreightAfterShipmentDto } from './freight-after-shipment.dto';
import { PostShipmentDetailsDto } from './post-shipment-details-dto';
import { PostShipmentDetailsEntity } from './post-shipment-details-entity';
import { ExpensesLogisticsDto } from './expenses-logistics-dto';
import { ExpensesLogisticsEntity } from './expenses-logistics-entity';

@Injectable()
export class ContainerAdapter {
  /**
   * 
   * @param containerDto 
   * @param isUpdate 
   * @returns 
   */
  // public convertDtoToEntity(  containerDto: ContainerDTO,  isUpdate: boolean = false ): Container {
  //   const container = new Container();
  //   container.containerId=containerDto.containerId;
  //   container.containerNumber=containerDto.containerNumber;
  //   container.soNumber=containerDto.soNumber;
  //   container.lineSeal=containerDto.lineSeal;
  //   container.eSeal=containerDto.eSeal;
  //   container.containerStatus=containerDto.containerStatus;
  //   container.loadingDate=containerDto.loadingDate;
  //   container.actualDate=containerDto.actualDate;
  //   container.vehicleNumber=containerDto.vehicleNumber;
  //   container.driverName=containerDto.driverName;
  //   container.phoneNumber=containerDto.phoneNumber;
  //   container.assignedBy=containerDto.assignedBy;
  //   container.isActive=containerDto.isActive==undefined?true:containerDto.isActive;
  //   if (isUpdate) {
  //       container.updatedUser = containerDto.updatedUser;
  //   } else {
  //       container.isActive = true;
  //       container.createdUser = containerDto.createdUser;
  //   }
  //  return container;
  // }
  // public convertEntityToDto(containerObject: Container): ContainerDTO {
  //   const containerDto= new ContainerDTO;
  //   containerDto.containerId=containerObject.containerId;
  //   containerDto.containerNumber=containerObject.containerNumber;
  //   containerDto.soNumber=containerObject.soNumber;
  //   containerDto.lineSeal=containerObject.lineSeal;
  //   containerDto.eSeal=containerObject.eSeal;
  //   containerDto.containerStatus=containerObject.containerStatus;
  //   containerDto.loadingDate=containerObject.loadingDate;
  //   containerDto.actualDate=containerObject.actualDate;
  //   containerDto.vehicleNumber=containerObject.vehicleNumber;
  //   containerDto.driverName=containerObject.driverName;
  //   containerDto.phoneNumber=containerObject.phoneNumber;
  //   containerDto.assignedBy=containerObject.assignedBy;
  //   containerDto.isActive = containerObject.isActive;
  //   containerDto.createdAt = containerObject.createdAt;
  //   containerDto.updatedAt = containerObject.updatedAt;
  //   containerDto.createdUser = containerObject.createdUser;
  //   containerDto.updatedUser = containerObject.updatedUser;
  //   containerDto.versionFlag = containerObject.versionFlag;
  //   return containerDto;
  // }

  public convertBookingDtoToEntity(containerInfo:BookContainerDto):Container{
    const container = new Container();
    container.expectedDeliveryDate = containerInfo.expectedDeliveryDate;
    container.referenceNumber = containerInfo.referenceNumber;
    container.saleOrderId = containerInfo.saleOrderId;
    container.containerNumber = containerInfo.containerNumber;
    container.scac = containerInfo.scac;
    container.vesselSchedule = containerInfo.vesselSchedule;
    container.vesselNumber = containerInfo.vesselNumber;
    container.lineSeal = containerInfo.lineSeal;
    container.transporter = containerInfo.transporter;
    container.vehicleNumber = containerInfo.vehicleNumber;
    container.driverName = containerInfo.driverName;
    container.driverPhoneNumber = containerInfo.driverPhoneNumber;
    container.containerSize = containerInfo.containerSize;
    container.cha = containerInfo.cha;
    container.modeOfExport = containerInfo.modeOfExport
    if(containerInfo.containerId){
      container.containerId = containerInfo.containerId;
      container.updatedUser = containerInfo.updatedUser;
    }else{
      container.createdUser = containerInfo.createdUser;
    }
    container.containerStatus = ContainerStatusEnum.BOOKED;
    container.unitId = containerInfo.unitId;
    return container;
  }
  public convertContainerDtoToEntity(containerInfo:BookContainerDto,checkList:number):Container{
    const container = new Container();
    container.expectedDeliveryDate = containerInfo.expectedDeliveryDate;
    container.referenceNumber = containerInfo.referenceNumber;
    container.containerNumber = containerInfo.containerNumber;
    container.saleOrderId = containerInfo.saleOrderId;
    container.scac = containerInfo.scac;
    container.vesselNumber = containerInfo.vesselNumber
    container.containerSize = containerInfo.containerSize;
    container.cha = containerInfo.cha;
    container.transporter = containerInfo.transporter;
    container.lineSeal = containerInfo.lineSeal;
    container.vehicleNumber = containerInfo.vehicleNumber;
    container.driverName = containerInfo.driverName;
    container.driverPhoneNumber = containerInfo.driverPhoneNumber;
    container.qcReport = containerInfo.qcReport;
    container.buyerInspectionReport  = containerInfo.buyerInspectionReport;
    container.vesselScheduleApproval = containerInfo.vesselScheduleApproval;
    container.temperature = containerInfo.temperature;
    container.temperaturee =containerInfo.temperaturee;
    if(containerInfo.containerId){
      container.containerId = containerInfo.containerId;
      container.updatedUser = containerInfo.updatedUser;
    }else{
      container.createdUser = containerInfo.createdUser;
    }
    container.containerStatus = ContainerStatusEnum.LOADED_AND_SEALED;
    container.unitId = containerInfo.unitId;
    container.checkListStatus = checkList
    return container;
  }

  public convertPostShipmentDtoToEntity(containerInfo:BookContainerDto,shippmentDetails:number):Container{
    
    
    const container = new Container();
    container.expectedDeliveryDate = containerInfo.expectedDeliveryDate;
    container.referenceNumber = containerInfo.referenceNumber;
    container.saleOrderId = containerInfo.saleOrderId;
    container.scac = containerInfo.scac;
    container.scrollNo = containerInfo.scrollNo; 
    container.scrollDate  = containerInfo.scrollDate;
    container.shippingBillDate = containerInfo.shippingBillDate;
    container.shippingBillNo = containerInfo.shippingBillNo;
    container.examinationDate = containerInfo.examinationDate;
    container.stuffingStartTime = containerInfo.stuffingStartTime;
    container.stuffingCompletionTime = containerInfo.stuffingCompletionTime;
    container.timeTakenForStuffing = containerInfo.timeTakenForStuffing;
    container.branchCode = containerInfo.branchCode;
    container.tempIndicatorNo1 = containerInfo.tempIndicatorNo1;
    container.tempIndicatorNo2 = containerInfo.tempIndicatorNo2;
    container.tempIndicatorNo3 = containerInfo.tempIndicatorNo3;
    // container.shippingLiner = containerInfo.shippingLiner;
    container.shippingLiner = containerInfo.shippingLiner
    container.eta = containerInfo.eta;
    container.etd = containerInfo.etd;

    container.vesselName = containerInfo.vesselName;
    container.vesselNumber = containerInfo.vesselNumber;
    container.blNo = containerInfo.blNo;
    container.authorisedBy = containerInfo.authorisedBy;;
    container.portCode = containerInfo.portCode;
    container.buyerInspectionReport=containerInfo.buyerInspectionReport;
    container.qcReport=containerInfo.qcReport;
    container.vesselScheduleApproval=containerInfo.vesselScheduleApproval;
    container.temperature=containerInfo.temperature;
    container.temperaturee=containerInfo.temperaturee
    container.shippmentDetailsStatus = shippmentDetails
    
    if(containerInfo.containerId){
      container.containerId = containerInfo.containerId;
      container.updatedUser = containerInfo.updatedUser;
    }else{
      container.createdUser = containerInfo.createdUser;
    }
    // container.containerStatus = ContainerStatusEnum.SHIPPED;
    container.unitId = containerInfo.unitId;
    return container;
  }

  public convertDispatchToPlantDtoToEntity(containerInfo:DispatchedToPlant):Container{
    const container = new Container();
    container.containerNumber = containerInfo.containerNumber;
    container.containerSize = containerInfo.containerSize;
    if(containerInfo.containerId){
      container.containerId = containerInfo.containerId;
    }
    return container;
  }

  public convertDoccumentApprovelOpenDtoToEntity(containerInfo:FreightAfterShipmentDto):Container{
    const container = new Container();
    container.freightAfterShipment = containerInfo.freightAfterShipment;
    if(containerInfo.saleOrderId){
      container.saleOrderId = containerInfo.saleOrderId;
    }
    return container;
  }

  public convertFillSealInfoDtoToEntity(containerInfo:ContainerDTO):Container{
    const container = new Container();
    container.loadingDate= containerInfo.loadingDate;
    container.containerNumber = containerInfo.containerNumber;
    container.driverPhoneNumber=containerInfo.driverPhoneNumber;
    container.vehicleNumber=containerInfo.vehicleNumber
    container.lineSeal=containerInfo.lineSeal;
    container.eSeal=containerInfo.eSeal;
    if(containerInfo.containerId){
      container.containerId = containerInfo.containerId;
    }
    return container;
  }

  convertDtoToEntity(dto: PostShipmentDetailsDto): PostShipmentDetailsEntity {
    const entity = new PostShipmentDetailsEntity();
    entity.vesselNo = dto.vesselNo;
    entity.vesselName = dto.vesselName;
    entity.marksNo = dto.marksNo;
    entity.dateOfIssue = dto.dateOfIssue;
    entity.lcNo = dto.lcNo;
    entity.lcName = dto.lcName;
    entity.lcBankAddress = dto.lcBankAddress;
    entity.lcAmount = dto.lcAmount;
    entity.saleOrderId = dto.saleOrderId;
    entity.createdUser = dto.createdUser
    if (dto.postShipmentId) {
        entity.postShipmentId = dto.postShipmentId;
        entity.updatedUser = dto.updatedUser
    }
    return entity;
}

convertEntityToDto(entity: PostShipmentDetailsEntity): PostShipmentDetailsDto {
    const dto = new PostShipmentDetailsDto();
    entity.postShipmentId = dto.postShipmentId;
    dto.vesselNo = entity.vesselNo
    dto.vesselName = entity.vesselName
    dto.marksNo = entity.marksNo
    dto.dateOfIssue = entity.dateOfIssue
   dto.lcNo = entity.lcNo
   dto.lcName = entity.lcName
   dto.lcBankAddress = entity.lcBankAddress
   dto.lcAmount = entity.lcAmount
   dto.saleOrderId = entity.saleOrderId

    return dto;
}



convertExpensesDtoToEntity(dto: ExpensesLogisticsDto): ExpensesLogisticsEntity {
  const entity = new ExpensesLogisticsEntity();
  entity.chaBill = dto.chaBill;
  entity.oceanFrieght = dto.oceanFrieght;
  entity.domesticFrieght = dto.domesticFrieght;
  entity.salesComission = dto.salesComission;
  entity.antiDumpingDuty = dto.antiDumpingDuty;
  entity.cvd = dto.cvd;
  entity.clearingForwarding = dto.clearingForwarding;
  entity.ddpTransport = dto.ddpTransport;
  entity.marineInsurance = dto.marineInsurance;
  entity.amc = dto.amc;
  entity.cvd = dto.cvd;
  entity.dutyDrawback = dto.dutyDrawback;
  entity.rodtepAmount = dto.rodtepAmount;
  entity.fdaDueDate = dto.fdaDueDate;
  entity.remarks = dto.remarks;
  entity.saleOrderId = dto.saleOrderId;
  entity.createdUser = dto.createdUser
  if (dto.expensesLogisticsId) {
      entity.expensesLogisticsId = dto.expensesLogisticsId;
      entity.updatedUser = dto.updatedUser
  }
  return entity;
}

convertExpensesEntityToDto(entity: ExpensesLogisticsEntity): ExpensesLogisticsDto {
  const dto = new ExpensesLogisticsDto();
  entity.expensesLogisticsId = dto.expensesLogisticsId;
  dto.chaBill = entity.chaBill
  dto.oceanFrieght = entity.oceanFrieght
  dto.domesticFrieght = entity.domesticFrieght
  dto.salesComission = entity.salesComission
 dto.antiDumpingDuty = entity.antiDumpingDuty
 dto.cvd = entity.cvd
 dto.clearingForwarding = entity.clearingForwarding
 dto.ddpTransport = entity.ddpTransport
 dto.marineInsurance = entity.marineInsurance;
 dto.amc = entity.amc;
 dto.cvd = entity.cvd;
 dto.dutyDrawback = entity.dutyDrawback;
 dto.rodtepAmount = entity.rodtepAmount;
 dto.fdaDueDate = entity.fdaDueDate;
 dto.remarks = entity.remarks;
 dto.saleOrderId = entity.saleOrderId

  return dto;
}
}
